import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  InvoiceCommoditySearchCriteria,
  RestInvoiceCommodityListRequest,
} from "../ds/ds.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupInvoiceModule,
  PopupCustomerModule,
} from "../modules/ModuleUtil.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  DatePickerComponent_adv,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
class SalesCommodityDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Sales Commodity Report  Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new InvoiceCommoditySearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      warehouses: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      isCollapsible_open: true,
      patternTypes: [],
      patternTypeLookupHandler: null,
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      customerLookupHandler: null,
      isShowServiceLookup: false,
      totalAmount: 0,
      totalQty: 0,
    };
    this.fabricCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.serviceCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }

    let patternTypes = attribute_cache.patternTypes;
    if (patternTypes != null || patternTypes != undefined) {
      patternTypes.map((attr) => {
        this.state.patternTypes.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  initLookupHandlers = () => {
    let criteria = this.state.criteria;
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      "Commodity"
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
      isShowServiceLookup: false,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (isEmptyString(data.customerCode) && isEmptyString(data.commodityCode)) {
      let errMsg = "Customer Code/Commodity is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else if (
      !isEmptyString(data.customerCode) &&
      isEmptyString(data.commodityCode)
    ) {
      let errMsg = "Commodity is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let isValid = false;
    isValid = this.validate(criteria);
    if (isValid) {
      this.loadSalesCommodityReportDetailsInquiryList(criteria);
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
    }
  };
  loadSalesCommodityReportDetailsInquiryList = (criteria) => {
    if (SecurityAccessManager.SalesCommodityDetailsInquiry_IsAccessible()) {
      ReportService.inquireInvoiceCommodityInquiryInfos(
        criteria,
        this.loadSalesCommodityReportPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSalesCommodityReportPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        customerSalesDataList.map((line, i) => {
          const formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
          });
          line.subTotalAmount = formatter.format(line.subTotalAmount);
          line.serviceAmount = formatter.format(line.serviceAmount);
          line.grandTotalAmount = formatter.format(line.grandTotalAmount);
        });
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateSalesCommodityReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let listRequest = new RestInvoiceCommodityListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SalesCommodityDetailsInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateInvoiceCommodityDetailsPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SalesCommodityDetailsInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateInvoiceCommodityDetailsPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateSkuBatchInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
 generateSkuBatchInventoryPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
         window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new InvoiceCommoditySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.commodityName = "";

    this.setState({
      criteria: criteria,
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      isShowServiceLookup: false,
      services: [],
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new InvoiceCommoditySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.commodityName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,

      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      totalPages: 0,
      isShowServiceLookup: false,
      services: [],
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateSalesCommodityReport(1);
  };
  generateExcel = () => {
    this.generateSalesCommodityReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollSkuPopup: isShowPopup,
    });
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust Po", "customerPONumber", true)
        .setStyleDetails("left", "4", "4", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WH P.o", "wareHousePurchaseOrderNumber", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Seal#", "sealNumber", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubTotal", "subTotalAmount", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalSubTotalAmount")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ServiceAmount", "serviceAmount", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalServiceAmount")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("GrandTotal", "grandTotalAmount", true)
        .setStyleDetails("right", "2", "2", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalGrandAmount")
    );
    return columns;
  };

  serviceOnChange = (e) => {
    let commodityCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(commodityCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.criteria;
      tempData.commodityCode = "";
      tempData.commodityName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        criteria: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "commodityCode" &&
      showAutoCompleteList === true &&
      commodityCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (commodityCode) => {
    let tempData = this.state.criteria;
    let serivceBean = null;
    let serviceData = null;
    this.state.patternTypes.map((ln) => {
      if (ln.code === commodityCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });

    if (!isEmpty(serivceBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.commodityCode = serivceBean.code;
      temp_criteria.commodityName = serivceBean.description;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        criteria: temp_criteria,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      criteria.commodityCode = "";
      criteria.serviceName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
        isShowServiceLookup: false,
        services: [],
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  render() {
    const inquiryDataList = this.state.inquiryDataList;
    const inquiryData = this.state.inquiryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          customerLookupHandler={this.state.customerLookupHandler}
          patternTypeLookupHandler={this.state.patternTypeLookupHandler}
          serviceCodeRef={this.serviceCodeRef}
          customerCodeRef={this.customerCodeRef}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          showHideSecondHeader={this.showHideSecondHeader}
          serviceOnChange={this.serviceOnChange}
          serviceEnterKeyEvent={this.serviceEnterKeyEvent}
          displayServiceAutoCompleteList={this.displayServiceAutoCompleteList}
        />

        <div>
          {this.state.isInquiryDatasFound && (
            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryColumns()}
                subHeaderData={inquiryData}
                label={"Inquiry List"}
              />
            </div>
          )}
        </div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let isDisableFields = props.isDisableFields;
  let isShowServiceLookup = props.isShowServiceLookup;
  let patternTypeLookupHandler = props.patternTypeLookupHandler;
  const serviceCodeRef = props.serviceCodeRef;
  const customerCodeRef = props.customerCodeRef;
  let customerLookupHandler = props.customerLookupHandler;
  const serviceOnChange = (e) => {
    props.serviceOnChange(e);
  };
  const serviceEnterKeyEvent = (e) => {
    props.serviceEnterKeyEvent(e);
  };
  const displayServiceAutoCompleteList = () => {
    props.displayServiceAutoCompleteList();
  };

  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>Commodity</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={serviceCodeRef}
            name="commodityCode"
            onChange={serviceOnChange}
            value={criteria.commodityCode}
            // placeholder="item"
            lookupRequired={true}
            lookupHandler={props.patternTypeLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={serviceEnterKeyEvent}
            autoCompleteListData={props.servicePageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayServiceAutoCompleteList}
            showAutoCompleteList={props.isShowAutoCompleteServiceList}
            // disabled={isDisableFields}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="commodityName"
            onChange={onChange}
            value={criteria.commodityName}
            disabled={true}
          />
        </Col>

        <Col sm="1">
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            <FormLabel>from Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromDate"
              onChange={onChange}
              value={criteria.fromDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toDate"
              onChange={onChange}
              value={criteria.toDate}
              disabled={isDisableFields}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}

function SalesCommodityReportInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SalesCommodityDetails {...props} name="" /> <br />
    </div>
  );
}

export default SalesCommodityReportInquiry;
